import { render, staticRenderFns } from "./ItemMenuNew.vue?vue&type=template&id=0e11fd72&scoped=true"
import script from "./ItemMenuNew.vue?vue&type=script&lang=js"
export * from "./ItemMenuNew.vue?vue&type=script&lang=js"
import style0 from "./ItemMenuNew.vue?vue&type=style&index=0&id=0e11fd72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e11fd72",
  null
  
)

export default component.exports